import { FC } from 'react';
import { Spinner } from 'react-bootstrap';

import { useNearbyVenuesQuery } from '@queries/index';

import { useCurrentUserCity } from '@hooks/useCurrentUserLocation';

import { useNavigate } from '@router/index';

import Button from '@components/buttons/Button';
import { VenueCard } from '@components/cards/VenueCard';
import { Screen } from '@components/layout/Screen/Screen';

import { PromoterRankingsContent } from '@screens/CommunityScreen/PromoterRankingsContent';
import { VenueRankingsContent } from '@screens/CommunityScreen/VenueRankingsContent';

const VENUE_REQUEST_ENABLED = true;

const DeprecatedContent = () => {
  const { venuesAreReady, venues } = useNearbyVenuesQuery();
  const navigate = useNavigate();

  return venuesAreReady ? (
    <div>
      {venues.map((venue) => (
        <VenueCard
          key={venue.title}
          venue={venue}
          onClick={() => navigate(`/venues/${venue._id}`)}
        />
      ))}
    </div>
  ) : (
    <div className="d-flex justify-content-center">
      <Spinner />
    </div>
  );
};

export const PromotersScreen: FC<{}> = () => {
  const { currentCity } = useCurrentUserCity();

  return (
    <Screen
      name="Promoters Screen"
      headerProps={{
        back: { to: '/discover' },
      }}
    >
      <Screen.Content maxWidth={425}>
        <PromoterRankingsContent cityId={currentCity._id} />
      </Screen.Content>
    </Screen>
  );
};
